import { AdminRegistrationDtoClient } from "@/api/registration-dto/dto/admin-registration.dto";
import { Badge } from "@/components/atoms/Badge";
import { PayementUtil } from "@/lib/payement-util";

interface RegistrationStatusBadgeProps {
  registration: AdminRegistrationDtoClient;
}

const RegistrationStatusBadge = ({
  registration: { examResult, exam, payementStatus },
}: RegistrationStatusBadgeProps) => {
  if (!PayementUtil.isPaid(payementStatus))
    return <Badge variant="orange">Pré-inscrit</Badge>;

  if (examResult) return <Badge variant="sky">Validé</Badge>;

  if (new Date(exam.date) > new Date())
    return <Badge variant="green">Inscrit</Badge>;

  return <Badge variant="red">En attente de résultats</Badge>;
};

export default RegistrationStatusBadge;
